module.exports = __webpack_public_path__ + "static/img/fish41.d65e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish41.png
// module id = rjZn
// module chunks = 0